export const AuxiliaryMap: { [key: string]: string[] } = {
  'java.time.LocalDate': ['java.time.DayOfWeek']
};
